import React, { useRef, useEffect } from 'react';
import { useSettings } from '@/context/SettingsContext';

interface ContentCardProps {
    children: React.ReactNode;
    className?: string;
}

const ContentCard: React.FC<ContentCardProps> = ({ children, className = '' }) => {
    const cardRef = useRef<HTMLDivElement>(null);
    const { isCardGlowEnabled } = useSettings();

    useEffect(() => {
        if (!isCardGlowEnabled) return;

        const card = cardRef.current;
        if (!card) return;

        let rect = card.getBoundingClientRect();

        const handleMouseEnter = () => {
            rect = card.getBoundingClientRect();
        };

        const handleMouseMove = (e: MouseEvent) => {
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            card.style.setProperty('--mouse-x', `${x}px`);
            card.style.setProperty('--mouse-y', `${y}px`);
        };

        card.addEventListener('mouseenter', handleMouseEnter, { passive: true });
        card.addEventListener('mousemove', handleMouseMove, { passive: true });
        
        return () => {
            card.removeEventListener('mouseenter', handleMouseEnter);
            card.removeEventListener('mousemove', handleMouseMove);
        };
    }, [isCardGlowEnabled]);

    return (
        <div ref={cardRef} className={`content-card ${className}`} suppressHydrationWarning>
            {children}
        </div>
    );
};

export default ContentCard;